"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useUserSessionState = void 0;
var _useUserSessionStatus2 = require("./useUserSessionStatus");
var _react = require("react");
var _constants = require("../../utils/constants");
var _reactRedux = require("react-redux");
var _userSelectors = require("../../store/user/userSelectors");
var _userActions = require("../../store/user/userActions");
var useUserSessionState = function useUserSessionState() {
  var dispatch = (0, _reactRedux.useDispatch)();
  var _useUserSessionStatus = (0, _useUserSessionStatus2.useUserSessionStatus)(),
    userSessionJourneyStatus = _useUserSessionStatus.userSessionJourneyStatus,
    isUserSessionLoaded = _useUserSessionStatus.isUserSessionLoaded;
  var marketingId = (0, _reactRedux.useSelector)(_userSelectors.selectMarketingId);
  var userSession = (0, _reactRedux.useSelector)(_userSelectors.selectUserSession);
  (0, _react.useEffect)(function () {
    var _userSession$characte;
    if (!isUserSessionLoaded) {
      return;
    }
    if (userSessionJourneyStatus === _constants.USER_SESSION_JOURNEY_STATUS.NEW_USER) {
      dispatch((0, _userActions.createUserSession)(marketingId));
      return;
    }
    var sessionState = (_userSession$characte = userSession.characteristic.find(function (item) {
      return item.name === 'questionnaireState';
    })) === null || _userSession$characte === void 0 ? void 0 : _userSession$characte.value;
    if (sessionState) {
      var parsedSessionState = JSON.parse(sessionState);
      dispatch((0, _userActions.resumeUserSession)(parsedSessionState));
    }
  }, [isUserSessionLoaded]);
};
exports.useUserSessionState = useUserSessionState;